import { useNavigate } from "react-router-dom";
import { Clock, AlertTriangle } from "lucide-react";
import { useOrg } from "@/context/OrgContext";

// Consistent trial-status strip shown across the app.
export default function TrialBanner() {
  const nav = useNavigate();
  const { subscription: s, can } = useOrg();
  if (!s || s.subscription_active) return null;

  if (s.trial_expired) {
    return (
      <div className="flex items-center justify-between gap-3 border-b border-destructive/30 bg-destructive/10 px-4 py-2 text-sm" data-testid="trial-banner-expired">
        <span className="flex items-center gap-2 text-red-300"><AlertTriangle className="h-4 w-4" /> Your free trial has ended. Subscribe to keep using BDVG AI.</span>
        {can("billing.manage") && (
          <button onClick={() => nav("/app/billing")} className="shrink-0 rounded-full bg-gradient-to-r from-gold-light to-gold px-4 py-1.5 text-xs font-semibold text-black" data-testid="trial-banner-upgrade">Choose a plan</button>
        )}
      </div>
    );
  }
  if (s.trialing && s.trial_days_left != null) {
    return (
      <div className="flex items-center justify-between gap-3 border-b border-gold/20 bg-gold/[0.06] px-4 py-2 text-sm" data-testid="trial-banner">
        <span className="flex items-center gap-2 text-gold"><Clock className="h-4 w-4" /> Free trial · <strong>{s.trial_days_left} {s.trial_days_left === 1 ? "day" : "days"} left</strong></span>
        {can("billing.manage") && (
          <button onClick={() => nav("/app/billing")} className="shrink-0 rounded-full border border-gold/40 px-4 py-1.5 text-xs font-semibold text-gold hover:bg-gold/10" data-testid="trial-banner-upgrade">Upgrade now</button>
        )}
      </div>
    );
  }
  return null;
}
